import { createTheme } from '@mui/material/styles'

// Story 175, S175 (GATE 3, P1.5-tema) -- the drawer is dark on ANY theme. Its HTML content reads the `--mdd-*`
// tokens of `machineDetailDrawer.css`; the few MUI pieces still inside it (LoadCapacityChart, the error Alert
// and the loading LinearProgress) read colours from the MUI theme, so they get a theme made of the SAME values.
// MUI needs parseable colours to derive its shades, hence the literals: keep them equal to the CSS fallbacks.
export const MACHINE_DETAIL_PALETTE = {
  surface: '#282828',
  surfaceHigh: '#363636',
  outline: '#363636',
  text: '#f9f9f9',
  muted: '#bbbbbb',
  accent: '#7ae0a9',
  danger: '#ff6b6b',
  warning: '#ffb74d',
  info: '#64b5f6'
}

const DRAWER_THEME_PALETTE = createTheme({
  palette: {
    mode: 'dark',
    background: { default: MACHINE_DETAIL_PALETTE.surface, paper: MACHINE_DETAIL_PALETTE.surface },
    text: { primary: MACHINE_DETAIL_PALETTE.text, secondary: MACHINE_DETAIL_PALETTE.muted },
    divider: MACHINE_DETAIL_PALETTE.outline,
    primary: { main: MACHINE_DETAIL_PALETTE.accent },
    success: { main: MACHINE_DETAIL_PALETTE.accent },
    warning: { main: MACHINE_DETAIL_PALETTE.warning },
    error: { main: MACHINE_DETAIL_PALETTE.danger },
    info: { main: MACHINE_DETAIL_PALETTE.info }
  }
}).palette

/**
 * The theme of the drawer's content: the page's theme (typography, date formats, tokens) with the drawer's
 * own dark palette in place of its palette. Module-level so ThemeProvider memoises it per outer theme.
 * @param {Object} outerTheme The theme of the page
 * @returns {Object} The same theme with the drawer palette
 */
export const machineDetailTheme = (outerTheme) => ({ ...outerTheme, palette: DRAWER_THEME_PALETTE })
